import api from "../client";
import { ENDPOINTS } from "../endpoints";

export interface UserResponse {
  id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  enabled: boolean;
  email_verified: boolean;
  mfa_enabled: boolean;
}

export interface UsersListResponse {
  users: UserResponse[];
  total: number;
  page: number;
  page_size: number;
}

export interface InviteUserRequest {
  email: string;
  first_name: string;
  last_name: string;
  role: "admin" | "member";
}

export interface InviteUserResponse {
  user_id: string;
  invitation_sent: boolean;
}

export const adminApi = {
  getUsers: async (
    page = 1,
    pageSize = 20,
    search = "",
  ): Promise<UsersListResponse> => {
    return api.get<UsersListResponse>(ENDPOINTS.ADMIN_USERS, {
      params: { page, page_size: pageSize, search },
    });
  },

  inviteUser: async (data: InviteUserRequest): Promise<InviteUserResponse> => {
    return api.post<InviteUserResponse>(ENDPOINTS.ADMIN_USERS_INVITE, data);
  },

  resendInvite: async (userId: string): Promise<{ success: boolean }> => {
    return api.post<{ success: boolean }>(
      ENDPOINTS.ADMIN_USERS_RESEND_INVITE(userId),
    );
  },

  changeUserRole: async (
    userId: string,
    role: "admin" | "member",
  ): Promise<{ success: boolean }> => {
    return api.put<{ success: boolean }>(
      ENDPOINTS.ADMIN_USERS_ROLE(userId),
      { role },
    );
  },

  disableUser: async (userId: string): Promise<{ success: boolean }> => {
    return api.put<{ success: boolean }>(
      ENDPOINTS.ADMIN_USERS_DISABLE(userId),
    );
  },

  enableUser: async (userId: string): Promise<{ success: boolean }> => {
    return api.put<{ success: boolean }>(
      ENDPOINTS.ADMIN_USERS_ENABLE(userId),
    );
  },

  removeUser: async (userId: string): Promise<{ success: boolean }> => {
    return api.delete<{ success: boolean }>(
      ENDPOINTS.ADMIN_USERS_DELETE(userId),
    );
  },
};

export default adminApi;
